enum MaskType {
    schedule = 0,
    duration = 1,
    until = 2
}

export default MaskType;